module.exports = __webpack_public_path__ + "static/governance-mobile.3fbfa781.webp";